
/**
 * GSC METRIC GOVERNANCE POLICY - V2.0
 * SOURCE DE VÉRITÉ UNIQUE : UI + PIPELINE + SCORING
 */

import { CalibrationStatus } from "../contracts";

export interface MetricRule {
    minLevel: number;
    requiresCalibration: boolean;
    weightKey: string;
}

// Configuration Maître de l'écosystème
export const METRIC_GOVERNANCE_POLICY: Record<string, MetricRule> = {
  "rhythm":          { minLevel: 1, requiresCalibration: true,  weightKey: 'timing' },
  "harmony":         { minLevel: 1, requiresCalibration: false, weightKey: 'harmony' },
  "posture":         { minLevel: 1, requiresCalibration: false, weightKey: 'posture' },
  "nuance":          { minLevel: 2, requiresCalibration: false, weightKey: 'nuance' },
  "cleanliness":     { minLevel: 3, requiresCalibration: false, weightKey: 'cleanliness' },
  "audio":           { minLevel: 4, requiresCalibration: false, weightKey: 'quality_score' }, // Module technique
  "tone":            { minLevel: 5, requiresCalibration: false, weightKey: 'timbre' },
  "synchronization": { minLevel: 6, requiresCalibration: true,  weightKey: 'stability' },
  "articulation":    { minLevel: 7, requiresCalibration: false, weightKey: 'articulation' }
};

// Fix: Export TAB_MIN_LEVEL as an alias for METRIC_GOVERNANCE_POLICY to resolve import error in viewPolicy.ts
export const TAB_MIN_LEVEL = METRIC_GOVERNANCE_POLICY;

/**
 * Décide si une métrique est "ACTIVE" (Débloquée pédagogiquement ET valide techniquement).
 * Si FALSE => Score à 0, Exclu de l'agrégation, verrouillé dans l'UI.
 */
export function isMetricActive(id: string, levelId: number, calibration: CalibrationStatus): boolean {
    const rule = METRIC_GOVERNANCE_POLICY[id];
    if (!rule) return true; // Les modules non listés (ex: report) sont toujours actifs

    const isUnlocked = levelId >= rule.minLevel;
    const isCalibrated = !rule.requiresCalibration || calibration === "VALID";

    return isUnlocked && isCalibrated;
}

/**
 * @deprecated Use isMetricActive for logic or getMinLevelForTab for labels.
 */
export function isTabUnlocked(levelId: number, tabId: string): boolean {
  return levelId >= (METRIC_GOVERNANCE_POLICY[tabId]?.minLevel || 1);
}

export function getMinLevelForTab(tabId: string): number {
    return METRIC_GOVERNANCE_POLICY[tabId]?.minLevel || 1;
}

export type { CalibrationStatus };
